import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { useLanguage } from "@/i18n/LanguageContext";
import { Languages } from "lucide-react";
import { getLanguageName } from "./constants";

export function TranslationPreviewCard({
  translationSourceLang,
  translationTargetLang,
  originalText,
  currentTranslation
}) {
  const { t } = useLanguage();

  return (
    <Card className="col-span-12 bento-card" data-testid="translation-preview-card">
      <CardHeader className="pb-4">
        <CardTitle className="flex items-center gap-2 text-white font-['Outfit']">
          <Languages className="w-5 h-5" />
          {t("translationPreview")}
          <span className="ml-2 text-sm font-normal text-zinc-400">
            ({translationSourceLang.toUpperCase()} → {translationTargetLang.toUpperCase()})
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <Label className="text-zinc-400 text-sm mb-2 block">
              {t("original")} ({getLanguageName(translationSourceLang)})
            </Label>
            <div className="bg-zinc-900/50 rounded-lg p-4 min-h-[100px] text-zinc-300" data-testid="original-text">
              {originalText || t("waitingAudio")}
            </div>
          </div>
          <div>
            <Label className="text-zinc-400 text-sm mb-2 block">
              {t("translation")} ({getLanguageName(translationTargetLang)})
            </Label>
            <div className="bg-zinc-900/50 rounded-lg p-4 min-h-[100px] text-white font-medium" data-testid="translated-text">
              {currentTranslation || t("waitingTranslation")}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
